module.exports = __webpack_public_path__ + "img/pic05.032ee897.png";